// LIBRARIES
import styled from "styled-components";

// MISC
import { COLORS, FONTS } from "constants/styleVariables";

export const ConfirmationModalContainer = styled.div`
  height: 264px;
  width: 380px;
  border-radius: 20px;
  background-color: ${COLORS.primaryWhite};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  outline: none;
  padding: 40px;
`;

export const HeaderContainer = styled.div`
  font-family: ${FONTS.newsharp};
  color: ${COLORS.cornflowerBlue};
  font-size: 30px;
`;

export const TextContainer = styled.div`
  font-family: ${FONTS.montserrat};
  font-size: 18px;
  color: ${COLORS.rainbowIndigo};
  margin-top: 20px;
  font-weight: 600;
  text-align: center;
`;

export const ButtonsWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
`;
